import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type CarrierAdminState = {
    carrierTabs: CarrierTab[];
    currentTab: string;
};

type CarrierTab = {
    key: string;
    display: string;
};

const baseSessionState = {
    carrierTabs: [],
    currentTab: 'search',
} as CarrierAdminState;

const slice = createSlice({
    name: 'carrierAdmin',
    initialState: baseSessionState,
    reducers: {
        addCarrierTab: (state, action: PayloadAction<CarrierTab>) => {
            state.carrierTabs.push(action.payload);
        },
        removeCarrierTab: (state, action) => {
            state.carrierTabs = state.carrierTabs.filter(
                (x) => x.key !== action.payload
            );
        },
        setCurrentTab: (state, action: PayloadAction<string>) => {
            state.currentTab = action.payload;
        },
    },
});

export const {addCarrierTab, removeCarrierTab, setCurrentTab} = slice.actions;

export default slice.reducer;
